// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';

export const DocumentPlusGlyph = (props: ComponentProps<'svg'>) => (
	<svg
		{...props}
		width="24px"
		height="24px"
		viewBox="7.5 0.5 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_10645_15672)">
			<rect width="16" height="16" transform="translate(8 8)" fill="white" fillOpacity="0.01" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.0619 8H10C9.46957 8 8.96086 8.21071 8.58579 8.58579C8.21071 8.96086 8 9.46957 8 10V22C8 22.5304 8.21071 23.0391 8.58579 23.4142C8.96086 23.7893 9.46957 24 10 24H22C22.5304 24 23.0391 23.7893 23.4142 23.4142C23.7893 23.0391 24 22.5304 24 22V14.9381C22.365 14.7342 20.8832 14.037 19.7084 13H12C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12C11 11.7348 11.1054 11.4804 11.2929 11.2929C11.4804 11.1054 11.7348 11 12 11H18.0703C17.5478 10.0968 17.1968 9.08194 17.0619 8ZM11.2929 15.2929C11.4804 15.1054 11.7348 15 12 15H20C20.2652 15 20.5196 15.1054 20.7071 15.2929C20.8946 15.4804 21 15.7348 21 16C21 16.2652 20.8946 16.5196 20.7071 16.7071C20.5196 16.8946 20.2652 17 20 17H12C11.7348 17 11.4804 16.8946 11.2929 16.7071C11.1054 16.5196 11 16.2652 11 16C11 15.7348 11.1054 15.4804 11.2929 15.2929ZM11.2929 19.2929C11.4804 19.1054 11.7348 19 12 19H16C16.2652 19 16.5196 19.1054 16.7071 19.2929C16.8946 19.4804 17 19.7348 17 20C17 20.2652 16.8946 20.5196 16.7071 20.7071C16.5196 20.8946 16.2652 21 16 21H12C11.7348 21 11.4804 20.8946 11.2929 20.7071C11.1054 20.5196 11 20.2652 11 20C11 19.7348 11.1054 19.4804 11.2929 19.2929Z"
				fill="#0C66E4"
			/>
		</g>
		<rect x="19" y="1" width="12" height="12" rx="6" fill="#22A06B" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25.5 6.5V4.5C25.5 4.36739 25.4473 4.24021 25.3536 4.14645C25.2598 4.05268 25.1326 4 25 4C24.8674 4 24.7402 4.05268 24.6464 4.14645C24.5527 4.24021 24.5 4.36739 24.5 4.5V6.5H22.5C22.3674 6.5 22.2402 6.55268 22.1464 6.64645C22.0527 6.74021 22 6.86739 22 7C22 7.13261 22.0527 7.25979 22.1464 7.35355C22.2402 7.44732 22.3674 7.5 22.5 7.5H24.5V9.5C24.5 9.63261 24.5527 9.75979 24.6464 9.85355C24.7402 9.94732 24.8674 10 25 10C25.1326 10 25.2598 9.94732 25.3536 9.85355C25.4473 9.75979 25.5 9.63261 25.5 9.5V7.5H27.5C27.6326 7.5 27.7598 7.44732 27.8536 7.35355C27.9473 7.25979 28 7.13261 28 7C28 6.86739 27.9473 6.74021 27.8536 6.64645C27.7598 6.55268 27.6326 6.5 27.5 6.5H25.5Z"
			fill="white"
		/>
		<defs>
			<clipPath id="clip0_10645_15672">
				<rect width="16" height="16" fill="white" transform="translate(8 8)" />
			</clipPath>
		</defs>
	</svg>
);
